import type { SortOption } from '@researcher/shared';

interface SortSelectorProps {
  value: SortOption;
  onChange: (sort: SortOption) => void;
}

const TABS: { label: string; value: SortOption }[] = [
  { label: 'Trending', value: 'trending' },
  { label: 'New', value: 'recent' },
  { label: 'Top', value: 'top' },
];

export default function SortSelector({ value, onChange }: SortSelectorProps) {
  return (
    <div className="flex items-center border-b border-gray-200 dark:border-gray-700">
      {TABS.map((tab) => (
        <button
          key={tab.value}
          onClick={() => onChange(tab.value)}
          className={`px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px ${
            value === tab.value
              ? 'border-pink-500 text-pink-600 dark:text-pink-400'
              : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
